// Supabase returns at most 1,000 rows per request (the project's "max rows" setting),
// silently dropping the rest. This fetches page after page until everything is in.
// buildQuery() must return a fresh query each time, with a stable order (end the
// order with a unique column such as id) so no rows are skipped or repeated.
export const fetchAllRows = async (buildQuery, pageSize = 1000) => {
  const rows = [];
  for (let from = 0; ; from += pageSize) {
    const { data, error } = await buildQuery().range(from, from + pageSize - 1);
    if (error) throw error;
    rows.push(...(data || []));
    if (!data || data.length < pageSize) break;
  }
  return rows;
};
